/*
 *   File : tab.js
 *   Author : https://evoqins.com
 *   Description : Custom tab component
 *   Integrations : NA
 *   Version : 1.0.0
*/

const CustomTab = (props) => {
    return (
        props.type === 4 ?
            <p className={`flex-fill text-center e-font-14-res mb-0 pb-2 me-4 e-font-16 e-alt-font-poppins  line-height-14px
                    ${props.tabIndex === props.tabData.id ? 'show-border e-text-egyptian-blue e-font-weight-600' : 'no e-text-dark-liver cursor-pointer e-font-weight-500'}`}
                onClick={() => props.handleChange(props.tabData.id)} >
                {props.tabData.label}
            </p>
            :
            props.type == 3 ?
                <span className={`${props.tabIndex === props.tabData.id
                    ? "e-border-1px-egyptian-blue"
                    : "border-transparent"
                    } e-text-eerie_black  e-bg-lavender_web cursor-pointer border-transparent d-flex align-items-center justify-content-center padding-8px-all-res px-sm-4 py-sm-2 e-border-radius-8 e-font-12-res e-font-16 e-primary-font-inter e-font-weight-400`}
                    onClick={() => props.handleChange(props.tabData.id)}
                >
                    {props.tabData.label}
                </span>
                :
                props.type == 2 ?
                    <span className={`${props.tabIndex === props.tabData.id
                        ? "e-bg-egyptian-blue  e-text-white"
                        : "e-text-raisin-black border-color-american-silver"
                        }  cursor-pointer border-transparent d-flex align-items-center justify-content-center padding-12px-lr padding-6-tb e-border-radius-32  e-font-12 e-alt-font-poppins e-font-weight-500`}
                        onClick={() => props.handleChange(props.tabData.id)}
                    >
                        {props.tabData.label}
                    </span>
                    :
                    <p className={`e-font-14-res mb-0 pb-2 me-4 e-font-16 e-alt-font-poppins e-font-weight-600 line-height-14px
                    ${props.tabIndex === props.tabData.id ? 'show-border e-text-egyptian-blue' : 'no e-text-dark-liver cursor-pointer'}`}
                        onClick={() => props.handleChange(props.tabData.id)} >
                        {props.tabData.label}
                    </p>
    )
}
export default CustomTab;